<div class="titulo-pagina">Gerir banco de LUDs</div>
<div class="area-centralizada">
    <app-painel-luds 
        [isGerirRecursos]="true"
        [bancoRecursos]="bancoRecursos"
    ></app-painel-luds>
</div>
